import { CreatedPartner } from '../../../api/partner/partnerApiTypes';

export type State =
  | { status: 'idle' }
  | { status: 'creating' }
  | { status: 'created', createdPartner: CreatedPartner };

export type Status = State['status'];

type CreatingSetAction = { type: 'creating/set', payload: boolean };
type PartnerCreatedAction = { type: 'partner/created', payload: CreatedPartner };
type StateResetAction = { type: 'state/reset' };
export type Action =
  | CreatingSetAction
  | PartnerCreatedAction
  | StateResetAction;

export const initialState: State = { status: 'idle' };

export function reducer(state: State, action: Action): State {
  switch (action.type) {
    case 'creating/set': {
      const status: Status = action.payload ? 'creating' : 'idle';

      if (state.status === 'created' || state.status === status) {
        return state;
      }

      return { status };
    }
    case 'partner/created': {
      return { status: 'created', createdPartner: action.payload };
    }
    case 'state/reset': {
      return initialState;
    }
    default:
      return state;
  }
}
